<template>
    <div>
        <div style="margin-bottom: 5px;">
            <el-input v-model="keyword" placeholder="请输入分类名称" suffix-icon="el-icon-search" style="width: 220px;"
                      @keyup.enter.native="loadPost"></el-input>
            <el-button type="primary" style="margin-left: 5px;" @click="loadPost">查询</el-button>
            <el-button type="success" @click="resetParam">重置</el-button>
            <el-button type="primary" style="margin-left: 5px;" @click="add">新增分类</el-button>
        </div>
        <el-table :data="tableData"
                  :header-cell-style="{ background: '#f2f5fc', color: '#555555' }"
                  border>
            <el-table-column prop="id" label="ID" width="80"></el-table-column>
            <el-table-column prop="name" label="分类名称" width="220"></el-table-column>
            <el-table-column prop="count" label="商品数量" width="120">
                <template slot-scope="scope">
                    <el-tag type="success" disable-transitions>{{scope.row.count}} 件</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="remark" label="备注" min-width="200"></el-table-column>
            <el-table-column prop="operate" label="操作" width="180">
                <template slot-scope="scope">
                    <el-button size="small" type="success" @click="mod(scope.row)">编辑</el-button>
                    <el-popconfirm title="确定删除吗？" @confirm="del(scope.row)" style="margin-left: 5px;">
                        <el-button slot="reference" size="small" type="danger">删除</el-button>
                    </el-popconfirm>
                </template>
            </el-table-column>
        </el-table>

        <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageNum"
                :page-sizes="[5, 10, 20, 30]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
        </el-pagination>

        <el-dialog :title="form.id ? '编辑分类' : '新增分类'" :visible.sync="centerDialogVisible" width="30%" center>
            <el-form ref="form" :rules="rules" :model="form" label-width="80px">
                <el-form-item label="名称" prop="name">
                    <el-col :span="20"><el-input v-model="form.name"></el-input></el-col>
                </el-form-item>
                <el-form-item label="备注">
                    <el-col :span="20"><el-input v-model="form.remark" type="textarea" :rows="2"></el-input></el-col>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="centerDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="save">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "ShopCategoryManage",
        data() {
            return {
                user: JSON.parse(sessionStorage.getItem('CurUser') || '{}'),
                tableData: [],
                keyword: '',
                pageNum: 1,
                pageSize: 10,
                total: 0,
                centerDialogVisible: false,
                form: {
                    id: '',
                    name: '',
                    remark: ''
                },
                rules: {
                    name: [{required: true, message: '请输入分类名称', trigger: 'blur'}]
                }
            }
        },
        methods: {
            resetForm() {
                this.$refs.form && this.$refs.form.resetFields();
            },
            add() {
                this.centerDialogVisible = true
                this.$nextTick(() => {
                    this.resetForm()
                    this.form = {id: '', name: '', remark: ''}
                })
            },
            mod(row) {
                this.centerDialogVisible = true
                this.$nextTick(() => {
                    this.form.id = row.id
                    this.form.name = row.name
                    this.form.remark = row.remark || ''
                })
            },
            del(row) {
                this.$axios.get(this.$httpUrl + '/shop/category/del', {
                    params: {
                        id: row.id,
                        operatorNo: this.user.no,
                        operatorName: this.user.name,
                        operatorRole: this.user.roleId
                    }
                }).then(res => res.data).then(res => {
                    if (res.code == 200) {
                        this.$message({message: '操作成功！', type: 'success'});
                        this.loadPost()
                    } else {
                        this.$message({message: res.msg || '操作失败！', type: 'error'});
                    }
                })
            },
            save() {
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        let url = this.form.id ? '/shop/category/update' : '/shop/category/save'
                        let body = Object.assign({}, this.form, {
                            operatorNo: this.user.no,
                            operatorName: this.user.name,
                            operatorRole: this.user.roleId
                        })
                        this.$axios.post(this.$httpUrl + url, body).then(res => res.data).then(res => {
                            if (res.code == 200) {
                                this.$message({message: '操作成功！', type: 'success'});
                                this.centerDialogVisible = false
                                this.loadPost()
                            } else {
                                this.$message({message: res.msg || '操作失败！', type: 'error'});
                            }
                        })
                    } else {
                        return false;
                    }
                });
            },
            handleSizeChange(val) {
                this.pageNum = 1
                this.pageSize = val
                this.loadPost()
            },
            handleCurrentChange(val) {
                this.pageNum = val
                this.loadPost()
            },
            resetParam() {
                this.keyword = ''
            },
            loadPost() {
                this.$axios.post(this.$httpUrl + '/shop/category/listPage', {
                    pageSize: this.pageSize,
                    pageNum: this.pageNum,
                    param: {keyword: this.keyword}
                }).then(res => res.data).then(res => {
                    if (res.code == 200) {
                        this.tableData = res.data
                        this.total = res.total
                    } else {
                        this.$message.error('获取数据失败')
                    }
                })
            }
        },
        beforeMount() {
            this.loadPost()
        }
    }
</script>

<style scoped>

</style>
